import { configureStore } from "@reduxjs/toolkit";
import activeRouteReducer from "./activeRouteSlice";
import startDateReducer from "./startDateSlice";
import endDateReducer from "./endDateSlice";
import dateRangeReducer from "./dateRangeSlice";

export default configureStore({
  reducer: {
    activeRoute: activeRouteReducer,
    startDate: startDateReducer,
    endDate: endDateReducer,
    dateRange: dateRangeReducer,
  },
});
